/**
 * PDP product explainer: Bubble auf Hauptbild; Modal kann per appendToBody unter body hängen → per ID finden.
 */
(function () {
  const roots = document.querySelectorAll("[data-product-explainer-video]");
  if (!roots.length) return;

  function pickSrc(root) {
    const mobile = root.getAttribute("data-explainer-src-mobile") || "";
    const desktop = root.getAttribute("data-explainer-src-desktop") || "";
    const isNarrow = window.matchMedia("(max-width: 767px)").matches;
    if (isNarrow && mobile) return mobile;
    return desktop || mobile;
  }

  function getModal(root) {
    const id = root.getAttribute("data-explainer-modal-id");
    if (id) {
      const byId = document.getElementById(id);
      if (byId) return byId;
    }
    return root.querySelector("modal-box");
  }

  function stopVideo(video) {
    if (!video) return;
    video.pause();
    try {
      video.currentTime = 0;
    } catch (e) {
      /* ignore */
    }
  }

  roots.forEach((root) => {
    const modal = getModal(root);
    const openBtn = root.querySelector("[data-explainer-open]");
    /* Nach appendToBody liegt modal-box unter body; Video sitzt nur noch im Modal */
    const video = modal ? modal.querySelector("[data-explainer-player]") : null;
    if (!modal || !openBtn || !video) return;

    const observer = new MutationObserver(() => {
      if (!modal.classList.contains("active")) {
        stopVideo(video);
      }
    });
    observer.observe(modal, {
      attributes: true,
      attributeFilter: ["class"],
    });

    openBtn.addEventListener("click", () => {
      window.lastFocusedElm = openBtn;

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "explainer_video_opened",
        product_id: root.dataset.productId || "",
        product_title: root.dataset.productTitle || "",
        product_handle: root.dataset.productHandle || "",
      });

      const src = pickSrc(root);
      if (src && video.getAttribute("src") !== src) {
        video.setAttribute("src", src);
        video.load();
      }
      modal.style.display = "block";
      modal.show();
      const play = () => {
        video.play().catch(() => {});
      };
      if (video.readyState >= 2) {
        play();
      } else {
        video.addEventListener("canplay", play, { once: true });
      }
    });
  });
})();
